import { i18n } from '@/plugins/i18n'

export const terminalTypes = {
     PAYMENT_HELPER : 1,
     IVR : 2,
     PARDAKHT_SHAKHSI : 3
}


export const terminalTypeStr = {
     PAYMENT_HELPER: i18n.t('gateway.gateway_types.dedicated'),
     IVR: i18n.t('gateway.gateway_types.ivr'),
     PARDAKHT_SHAKHSI: i18n.t('gateway.gateway_types.pardakht_shakhsi'),

     get(terminal_type) {
          let terminal_type_str = null;

          Object.keys(terminalTypeStr).forEach(item => {
               if (terminalTypes[item] === terminal_type) {
                    terminal_type_str = terminalTypeStr[item];
               }
          });

          return terminal_type_str;
     }
};